import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'kd-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

    @Input()
    fixed: boolean;

    constructor() { }

    ngOnInit() {
    }
}
